import React from 'react';
import { Reveal } from './Reveal';
const stats: [string, string][] = [['10', 'COMPLETE VOLUMES'], ['500+', "PAGINA'S"], ['45', 'LEEREENHEDEN'], ['100%', 'KLAAR VOOR DE TRAINING']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-146" data-mp="1o9u2q028v2kz">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-147" data-mp="1jd3mncqfw6zk">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-148" data-mp="1ef236qp3q5nk" data-mpi={index}>
            <span className="mb-1 font-serif text-3xl font-bold text-brand-green md:text-4xl" data-id="element-149" data-mp="15l5kjlv5bbcw">
              {value}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-150" data-mp="vmgf4skfrjdj">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}